/* eslint-disable no-param-reassign */
import * as types from '../types';
import * as LS from '../../utils/storage';

const auth = {
  state: {
    accessToken: LS.getItem('accessToken'),
    refreshToken: LS.getItem('refreshToken'),
    wxuser: LS.getItem('wxuser'),
    user: LS.getItem('user'),
  },
  getters: {
    accessToken: state => state.accessToken,
    refreshToken: state => state.refreshToken,
    wxuser: state => state.wxuser,
    user: state => state.user,
  },
  mutations: {
    [types.AUTH_LOGIN]: (state, data) => {
      LS.setItem('accessToken', data.accessToken);
      LS.setItem('refreshToken', data.refreshToken);
      state.accessToken = data.accessToken;
      state.refreshToken = data.refreshToken;
    },
    [types.AUTH_LOGOUT]: (state) => {
      LS.removeItem('user');
      LS.removeItem('accessToken');
      LS.removeItem('refreshToken');
      state.user = null;
      state.accessToken = null;
      state.refreshToken = null;
    },
    [types.AUTH_SET_WXUSER]: (state, data) => {
      LS.setItem('wxuser', data, 30 * 24 * 3600 * 1000);
      state.wxuser = data;
    },
    [types.AUTH_SET_USER]: (state, data) => {
      LS.setItem('user', data);
      state.user = data;
    },
  },
  actions: {},
};

export default auth;



// WEBPACK FOOTER //
// ./src/store/modules/auth.js